import {StoreType} from '..';
//types
import {IGetTeamResData} from '../../utils/types';

export const getTeamLoaderSelector = (state: StoreType): boolean => state.organizationTeamStore.isLoading;

export const getTeamDataSelector = (state: StoreType): IGetTeamResData => state.organizationTeamStore.teamData;

export const generatedPasswordSelector = (state: StoreType): string => state.organizationTeamStore.password;
